export default "__VITE_ASSET__6894ce5a__"